var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10.2557,
    r: 8,
    fill: "#B3B3B3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.29218 10.2558L6.81365 7.77724C6.6181 7.58169 6.6181 7.26464 6.81365 7.06909C7.0092 6.87354 7.32625 6.87354 7.5218 7.06909L10.0003 9.54761L12.4788 7.06909C12.6744 6.87354 12.9914 6.87354 13.187 7.06909C13.3825 7.26464 13.3825 7.58169 13.187 7.77724L10.7085 10.2558L13.187 12.7343C13.3825 12.9298 13.3825 13.2469 13.187 13.4424C12.9914 13.638 12.6744 13.638 12.4788 13.4424L10.0003 10.9639L7.5218 13.4424C7.32625 13.638 7.0092 13.638 6.81365 13.4424C6.6181 13.2469 6.6181 12.9298 6.81365 12.7343L9.29218 10.2558Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.b29134ed.svg";
export { ForwardRef as ReactComponent };